// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","timeline":"_3-ne","marker":"_1640","line":"_2mRO","timelineRow":"_3hGJ","timelineItem":"_3qDf","arm":"_3eMJ","icon":"_1d4T"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Timeline/Timeline.scss
// module id = 1NxB
// module chunks = 0